import { render } from "./LicensedInsured.vue?vue&type=template&id=aa3af726&scoped=true"
import script from "./LicensedInsured.vue?vue&type=script&lang=js"
export * from "./LicensedInsured.vue?vue&type=script&lang=js"

import "./LicensedInsured.vue?vue&type=style&index=0&id=aa3af726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3af726"]])

export default __exports__